// router
import router from './router'
// vuex
import { mapGetters } from 'vuex'
// store
import store from './store'
// momentjs
import moment from 'moment'
// numeral
import numeral from 'numeral'
// moment timezone
import tz from 'moment-timezone'
// config project
import project from '@/project'
// Create VueI18n instance with options
import i18n from './plugins/i18n'
import { FEE_CALC_TYPE, TAX_FORM_TYPE } from './helpers/enum'
import { getDisplayTaxNameRate, getMasterDataText, splitBracedString } from './helpers'

var monthNamesThai = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤษจิกายน', 'ธันวาคม']
var monthNamesThaiSort = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
var monthNamesEng = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
var monthNamesEngSort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

var loopLoading = null

/**
 ** libs function use for only this file
 **/
var toCurrentTimeZone = function (date) {
  // get user time zone
  let timezone = moment.tz.guess()
  return moment(date).tz(timezone)
}

var capitalizeFirstLetter = ([first, ...rest], locale = navigator.language) =>
  first === undefined ? '' : first.toLocaleUpperCase(locale) + rest.join('')

var setTabTitle = function (title) {
  if (process.env.NODE_ENV !== 'production') {
    title += ` (${capitalizeFirstLetter(process.env.NODE_ENV)})`
  } else {
    title += ' - TreeSoft.io'
  }
  document.title = title
}

var removeModals = function () {
  $('body > .modal, body > .modal-backdrop').remove()
  $('body').removeClass('modal-open')
}

var removeTooltips = function () {
  $('body > .vs-tooltip').remove()
}

const addTax = (taxes, tax, taxTotal, serviceChargeTotal, feeTotal) => {
  const foundIndex = taxes.findIndex((taxItem) => taxItem.name === tax.name)
  if (foundIndex === -1) {
    taxes.push({
      id: tax.tax_id,
      form_type: tax.form_type,
      group_name: tax.group_name,
      name: tax.tax_name,
      type: tax.type,
      amount: tax.amount,
      taxTotal: taxTotal,
      serviceChargeTotal: serviceChargeTotal,
      feeTotal: feeTotal,
    })
  } else {
    if (tax.type === 'exclude') {
      taxes[foundIndex].taxTotal += taxTotal
      taxes[foundIndex].serviceChargeTotal += serviceChargeTotal
      taxes[foundIndex].feeTotal += feeTotal
    } else {
      taxes[foundIndex].taxTotal -= taxTotal
      taxes[foundIndex].serviceChargeTotal -= serviceChargeTotal
      taxes[foundIndex].feeTotal -= feeTotal
    }
  }
  return taxes
}

const calcTax = (price, tax, groupTaxes) => {
  let formula
  if (tax.type == 'include') {
    formula = taxIncFn
  } else if (tax.type == 'exclude') {
    formula = taxExcFn
  }
  return calcTaxWithFee(price, tax, formula, groupTaxes)
}

const taxIncFn = (price, taxRate) => {
  return price - (price * 100 / (100 + taxRate))
}

const taxExcFn = (price, taxRate) => {
  return price * taxRate / 100
}

const calcTaxWithFee = (price, tax, formula, groupTaxes) => {
  let taxTotal = 0
  let serviceChargeTotal = 0
  let feeTotal = 0
  if (tax.form_type === TAX_FORM_TYPE.TAX) {
    taxTotal = formula(price, tax.amount)
  } else if (tax.form_type === TAX_FORM_TYPE.SERVICE_CHARGE) {
    serviceChargeTotal = formula(price, tax.amount)
  } else if (tax.form_type === TAX_FORM_TYPE.FEE) {
    if (tax.fee.calc_type === FEE_CALC_TYPE.NET) {
      feeTotal = formula(price, tax.amount)
    } else if (tax.fee.calc_type === FEE_CALC_TYPE.CUSTOM) {
      const refTaxId = tax.fee.calc_tax_id
      const refTax = groupTaxes.find((taxItem) => taxItem.id === refTaxId)
      if (refTax) {
        feeTotal = formula(refTax.feeTotal, tax.amount)
      }
    }
  }
  return {
    taxTotal,
    serviceChargeTotal,
    feeTotal,
  }
}

var getTotal = function (orders, includeDiscount = true, includeTax = true) {
  function round(n) {
    if (!store.getters.getPosSetting.format_number.is_round) {
      return n
    }
    return Math.round(n)
  }
  function getResultPrice(order) {
    let result = order.price
    for (let m in order.modifiers) {
      for (let n in order.modifiers[m].options) {
        let optionPrice = order.modifiers[m].options[n].price
        result += optionPrice
      }
    }
    return result
  }

  let currency = store.getters.getCurrency
  var subTotalNumber = 0
  var discountNumber = 0
  var vatExcNumber = 0
  var vatIncNumber = 0 // vat inclusive
  var whtNumber = 0
  let feeNumber = 0
  let serviceChargeNumber = 0
  var totalNumber = 0
  var totalUntaxed = 0
  let groupTaxes = []

  const taxesWithCalc = []

  for (let i in orders) {
    let order = orders[i]
    var oPrice = getResultPrice(order) // order price included only modifiers
    var rPrice = oPrice * order.quantity // order price with discounts
    var rDiscount = 0 // discount amount of each order
    var rVatExc = 0 // vat exclusive of each order
    var rVatInc = 0 // vat inclusive of each order
    var rWht = 0 // withholding tax amount of each order
    let rFee = 0 // fee amount of each order
    let rServiceCharge = 0 // service charge amount of each order
    var rUntaxed = 0 // untaxed amount of each order

    subTotalNumber += rPrice

    var tempDiscountPercent = 0 // tempDiscountPercent is not number but percentage such as 10%
    var tempDiscountNumber = 0 // tempDiscountNumber is not percentage but number such as 100 BATH

    if (includeDiscount) {
      for (let j in order.discounts) {
        let discount = order.discounts[j]
        if (discount) {
          const discountValueType = discount.value_type
          const discountValueAmount = discount.value_amount
          if (discountValueType == 'percentage') {
            tempDiscountPercent += discountValueAmount
          } else if (discountValueType == 'number') {
            tempDiscountNumber += discountValueAmount
          }
        }
      }
    }

    let discountA = tempDiscountPercent > 0 ? (oPrice - oPrice * ((100 - tempDiscountPercent) / 100)) : 0 // final discount of percent
    let discountB = tempDiscountNumber // final discount of number

    rDiscount += (discountA * order.quantity) + discountB
    rPrice -= rDiscount
    rUntaxed = rPrice
    discountNumber += rDiscount

    if (includeTax) {
      for (let k in order.taxes) {
        let tax = order.taxes[k]
        let inc = null
        let exc = null
        let taxResult = 0
        let serviceChargeResult = 0
        let feeResult = 0

        /**
         * TODO: refactor this later
         * set default form_type
         * ใช้สำหรับ so, inv, po
         */
        if (!tax.form_type) {
          tax.form_type = TAX_FORM_TYPE.TAX
        }

        if (tax.type == 'include') {
          const { taxTotal, serviceChargeTotal, feeTotal } = calcTax(rUntaxed, tax, groupTaxes)
          rVatInc = taxTotal
          rServiceCharge += serviceChargeTotal
          rFee += feeTotal
          rUntaxed -= rVatInc
          inc = rVatInc
          taxResult = taxTotal
          serviceChargeResult = serviceChargeTotal
          feeResult = feeTotal
          groupTaxes = addTax(groupTaxes, tax, taxTotal, serviceChargeTotal, feeTotal)
        } else if (tax.type == 'exclude') {
          if (tax.amount < 0) { // หัก ณ ที่จ่าย จำนวนจะติดลบเสมอ
            const { taxTotal, serviceChargeTotal, feeTotal } = calcTax(rUntaxed, tax, groupTaxes)
            rWht += taxTotal
            rServiceCharge += serviceChargeTotal
            rFee += feeTotal
            taxResult = taxTotal
            serviceChargeResult = serviceChargeTotal
            feeResult = feeTotal
            groupTaxes = addTax(groupTaxes, tax, taxTotal, serviceChargeTotal, feeTotal)
          } else {
            const { taxTotal, serviceChargeTotal, feeTotal } = calcTax(rUntaxed, tax, groupTaxes)
            rVatExc += taxTotal
            rServiceCharge += serviceChargeTotal
            rFee += feeTotal
            exc = taxTotal
            taxResult = taxTotal
            serviceChargeResult = serviceChargeTotal
            feeResult = feeTotal
            groupTaxes = addTax(groupTaxes, tax, taxTotal, serviceChargeTotal, feeTotal)
          }
        }

        taxesWithCalc.push({
          ...tax,
          result: {
            exclusive: exc,
            inclusive: inc,
            taxTotal: taxResult,
            serviceChargeTotal: serviceChargeResult,
            feeTotal: feeResult,
          },
        })
      }
    }

    vatExcNumber += rVatExc
    vatIncNumber += rVatInc
    whtNumber += rWht
    serviceChargeNumber += rServiceCharge
    feeNumber += rFee
    totalUntaxed += rUntaxed
  }

  totalNumber = subTotalNumber - discountNumber + vatExcNumber + whtNumber + serviceChargeNumber

  const getNumber = (number) => {
    return parseFloat(currencyFormatter(round(number), { code: currency, symbol: '' }).replace(/,/g, ''))
  }

  groupTaxes = groupTaxes.map((tax) => {
    return {
      ...tax,
      taxTotal: getNumber(tax.taxTotal),
      serviceChargeTotal: getNumber(tax.serviceChargeTotal),
      feeTotal: getNumber(tax.feeTotal),
    }
  })

  return {
    discount: parseFloat(currencyFormatter(round(discountNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
    taxes: {
      orders: taxesWithCalc,
      vat: {
        exclusive: parseFloat(currencyFormatter(round(vatExcNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
        inclusive: parseFloat(currencyFormatter(round(vatIncNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
      },
      wht: parseFloat(currencyFormatter(round(Math.abs(whtNumber)), { code: currency, symbol: '' }).replace(/,/g, '')),
      all: parseFloat(currencyFormatter(round(vatExcNumber) + vatIncNumber + Math.abs(whtNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
    },
    serviceCharge: {
      all: parseFloat(currencyFormatter(round(serviceChargeNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
    },
    fee: {
      all: parseFloat(currencyFormatter(round(feeNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
    },
    groupTaxes: groupTaxes,
    untaxed: parseFloat(currencyFormatter(round(totalUntaxed), { code: currency, symbol: '' }).replace(/,/g, '')),
    sub: parseFloat(currencyFormatter(round(subTotalNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
    preTax: parseFloat(currencyFormatter(round(subTotalNumber - discountNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
    grand: parseFloat(currencyFormatter(round(totalNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
    payment: parseFloat(currencyFormatter(round(totalNumber) + Math.abs(whtNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
  }
}

var getTaxesByOrders = function(orders, isGroupTaxName = true) {
  let taxes = []
  for (const order of orders) {
    const total = this.getTotal([order])
    taxes = [
      ...taxes,
      ...total.taxes.orders,
    ]
  }
  taxes = this.getFinalTaxes(taxes, isGroupTaxName)
  return taxes
}

var getFinalTaxes = function(taxes, isGroupTaxName = true) {
  const results = taxes
    // sum up total
    .reduce((acc, cur) => {
      const findIndex = acc.findIndex((item) => item.tax_id === cur.tax_id)
      if (findIndex !== -1) {
        acc[findIndex].result.taxTotal += cur.result.taxTotal
        acc[findIndex].result.serviceChargeTotal += cur.result.serviceChargeTotal
        acc[findIndex].result.feeTotal += cur.result.feeTotal
      } else {
        acc.push(cur)
      }
      return acc
    }, [])
    .map((item) => {
      return {
        ...item,
        name: item.tax_name || item.name,
        total: (() => {
          if (item.form_type === TAX_FORM_TYPE.TAX) {
            return item.result.taxTotal
          }
          else if (item.form_type === TAX_FORM_TYPE.SERVICE_CHARGE) {
            return item.result.serviceChargeTotal
          }
          else if (item.form_type === TAX_FORM_TYPE.FEE) {
            return item.result.feeTotal
          }
          else {
            return 0
          }
        })(),
      }
    })
    // filter only display result
    .filter((item) => {
      if (item.fee != null) {
        return item.is_display_fee_result === true
      }
      return true
    })
    // group tax
    .reduce((acc, cur) => {
      if (cur.group_name && isGroupTaxName) {
        const findIndex = acc.findIndex((item) => item.group_name === cur.group_name)
        if (findIndex !== -1) {
          acc[findIndex].total += cur.total
        } else {
          acc.push({
            ...cur,
            displayText: `${cur.group_name}`,
          })
        }
      } else {
        acc.push({
          ...cur,
          displayText: getDisplayTaxNameRate(getMasterDataText(cur.name, this.$t), cur.amount),
        })
      }
      return acc
    }, [])

  // sorting
  const taxesData = results.filter((v) => v.form_type === TAX_FORM_TYPE.TAX)
  const serviceChargeData = results.filter((v) => v.form_type === TAX_FORM_TYPE.SERVICE_CHARGE)
  const feeData = results.filter((v) => v.form_type === TAX_FORM_TYPE.FEE)

  return [
    ...serviceChargeData,
    ...taxesData,
    ...feeData,
  ]
}

var getPaidTotal = function (payments) {
  let currency = store.getters.getCurrency
  let total = 0
  payments.map(p => {
    if (p.status == 'paid') {
      total += p.payment.amount
    }
  })
  return parseFloat(
    new Intl.NumberFormat(
      'en-US',
      { style: 'currency', currencyDisplay: 'code', currency: currency }
    )
      .format(total)
      .replace(currency, '')
      .replace(/,/g, '')
  )
}

var removeZero = function (number) {
  return number.toString().replace(/^0+/, '')
}

var isANumber = function isANumber(n) {
  if (n == '.' || n == '-') return true
  var numStr = /^-?(\d+\.?\d*)$|(\d*\.?\d+)$/
  return numStr.test(n.toString())
}

const getThaiDate = (date, format, { short = false }) => {
  var d = new Date(date)
  const months = short ? monthNamesThaiSort : monthNamesThai
  const formatArr = format.split('/')
  return formatArr.reduce((acc, cur) => {
    if (cur === 'YYYY') {
      acc.push(d.getFullYear() + 543)
    } else if (cur === 'MM') {
      acc.push(months[d.getMonth()])
    } else {
      acc.push(d.getDate())
    }
    return acc
  }, []).join(' ')
}

var getThaiMonth = function (month) {
  return monthNamesThai[month]
}

var getEngDate = function (date, format, { short = false }) {
  var d = new Date(date)
  const months = short ? monthNamesEngSort : monthNamesEng
  const formatArr = format.split('/')
  return formatArr.reduce((acc, cur) => {
    if (cur === 'YYYY') {
      acc.push(d.getFullYear())
    } else if (cur === 'MM') {
      acc.push(months[d.getMonth()])
    } else {
      acc.push(d.getDate())
    }
    return acc
  }, []).join(' ')
}

var getEngMonth = function (month) {
  return monthNamesEng[month]
}

const getLocalMonth = (monthAtIdx, lang) => {
  if (lang.toLowerCase() == 'en') {
    return getEngMonth(monthAtIdx)
  } else if (lang.toLowerCase() == 'th') {
    return getThaiMonth(monthAtIdx)
  }
}

var getCenterPosition = function (_width, _height, _window) {
  var dualScreenLeft = _window.screenLeft != undefined ? _window.screenLeft : _window.screenX
  var dualScreenTop = _window.screenTop != undefined ? _window.screenTop : _window.screenY

  var width = _window.innerWidth ? _window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
  var height = _window.innerHeight ? _window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

  var systemZoom = width / _window.screen.availWidth
  var left = (width - _width) / 2 / systemZoom + dualScreenLeft
  var top = (height - _height) / 2 / systemZoom + dualScreenTop

  return {
    left: left,
    top: top,
  }
}

var currencyFormatter = function (number, options) {
  const currency = options.code
  const symbol = options.symbol
  const numberFormated = new Intl.NumberFormat(
    'en-US',
    {
      style: 'currency',
      currency: currency,
      ...(() => {
        if (symbol === undefined) {
          return null
        }
        return {
          currencyDisplay: 'code',
        }
      })(),
    }
  )
    .format(number).replace(/\s/g, '')

  if (symbol === undefined) {
    return numberFormated
  }

  return numberFormated.replace(currency, options.symbol)
}

export default {
  computed: {
    ...mapGetters({
      auth: 'getAuth',
      dateformat: 'getDateFormat',
      getAppCurrent: 'getAppCurrent',
      getLang: 'getLang',
      shopInfo: 'getShopInfo',
    }),
    isPricingPayAsYouGo() {
      return this.shopInfo.pricing.type == 'pay_as_you_go'
    },
    isPricingPackage() {
      return this.shopInfo.pricing.type == 'package'
    },
  },
  methods: {
    isANumber,
    initPage(opts) {
      // set last router
      store.dispatch('setLastRouter', router.history.current.name)
      // set section
      store.dispatch('setSection', opts.section)
      // set title
      setTabTitle(opts.name)
      // set header
      store.dispatch('setHeader', opts.name)

      if (this.getAppCurrent.app_id !== null) {
        // set prev
        store.dispatch('setAppPrev', this.getAppCurrent)
      }
      if (opts.current) {
        // set current
        store.dispatch('setAppCurrent', opts.current)
      }
    },
    getObject(json) {
      let temp = JSON.stringify(json)
      return JSON.parse(temp)
    },
    setTabTitle(title) {
      return setTabTitle(title)
    },
    setModal(id) {
      if ($('body > ' + id).length == 0) {
        // move modal to outside this element
        $(id).appendTo('body')
      } else {
        // remove modal in this element
        $('body > ' + id).remove()
        // move modal to outside this element
        $(id).appendTo('body')
      }
    },
    pad(n, width, z) {
      z = z || '0'
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    },
    round(number, places) {
      return +(Math.round(number + 'e+' + places) + 'e-' + places)
    },
    // use for display number
    getNumber(number) {
      let originNumber = number

      if (number === undefined || number === '' || number === null) return

      if (typeof number === 'string') {
        number = parseFloat(number.replace(/,/g, ''))
      }

      if (Number.isNaN(number)) {
        return originNumber
      }

      const shop_info = this.auth.shop_info
      const settings = shop_info.settings
      const appearance = settings.general.appearance
      const format_number = appearance.format_number
      const place = format_number.decimal.place
      const use_comma = format_number.use_comma
      let foundDot = number.toString().indexOf('.') >= 0
      if (!use_comma) {
        return number.toLocaleString('en-US', {
          minimumFractionDigits: place,
          maximumFractionDigits: place,
        }).replace(',', '')
      }
      return number.toLocaleString('en-US', {
        minimumFractionDigits: place,
        maximumFractionDigits: place,
      })
    },
    numberel(value, format = '0,0') {
      return numeral(value).format(format)
    },
    numberelWithFriendlyFormat(value, format = '0,0') {
      const friendlyFormat = this.getFriendlyFormatNumber(value, format)
      return this.numberel(value, friendlyFormat)
    },
    getFriendlyFormatNumber(number, format) {
      if (number >= 1) {
        return format.replace(/(\[\d.*\])$/g, '')
      }
      return format
    },
    validateEmail(email) {
      var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      return re.test(email.toLowerCase())
    },
    validateUsername(evt) {
      evt = (evt) || window.event

      var reg = /^[a-zA-Z0-9]+$/
      var matches = evt.key.match(reg)

      if (matches === null) {
        evt.preventDefault()
      }

      return true
    },
    getTotalPrice(price, discounts) {
      var result = price
      for (let i in discounts) {
        if (discounts[i].type == 'percentage') {
          result -= result / 100 * discounts[i].amount
        } else {
          result -= discounts[i].amount
        }
      }
      return result
    },
    getProductFullName(product_name, attributes) {
      var fullname = ''
      var option = ''
      for (let i in attributes) {
        if (i == 0) {
          option += '('
        }
        // option +=  attributes[i].name + ' '
        option += attributes[i].option
        if (i < attributes.length - 1) {
          option += ', '
        } else {
          option += ')'
        }
      }
      if (attributes.length > 0) {
        fullname = product_name + ' ' + option
      } else {
        fullname = product_name
      }
      return fullname
    },
    getAttributesFullName(attributes) {
      var fullname = ''
      for (let i in attributes) {
        fullname += attributes[i].name + ' ' + attributes[i].option
        if (i < attributes.length - 1) {
          fullname += ', '
        }
      }
      return fullname
    },
    dataTableOption() {
      var headerOffset = 0

      if ($('#content .header').position()) {
        headerOffset = $('#content .header').position().top + $('#content .header').outerHeight() - 7
      }

      if ($('#main-pos header').position()) {
        headerOffset = $('#main-pos header').outerHeight() + $('#main-pos .top-bar').outerHeight() - 7
      }

      return {
        fixedHeader: {
          header: true,
          footer: false,
          headerOffset: headerOffset,
        },
        pageLength: 10, // 10
        bSort: false,
        // info: false,
        // paging: false,
        language: {
          'decimal': i18n.t('table.decimal'),
          'emptyTable': i18n.t('table.emptyTable'),
          'info': i18n.t('table.info'),
          'infoEmpty': i18n.t('table.infoEmpty'),
          'infoFiltered': i18n.t('table.infoFiltered'),
          'infoPostFix': i18n.t('table.infoPostFix'),
          'thousands': i18n.t('table.thousands'),
          'lengthMenu': i18n.t('table.lengthMenu'),
          'loadingRecords': i18n.t('table.loadingRecords'),
          'processing': i18n.t('table.processing'),
          'search': i18n.t('table.search'),
          'zeroRecords': i18n.t('table.zeroRecords'),
          'paginate': {
            'first': i18n.t('table.paginate.first'),
            'last': i18n.t('table.paginate.last'),
            'next': i18n.t('table.paginate.next'),
            'previous': i18n.t('table.paginate.previous'),
          },
          'aria': {
            'sortAscending': i18n.t('table.aria.sortAscending'),
            'sortDescending': i18n.t('table.aria.sortDescending'),
          },
        },
      }
    },
    getDate(date) {
      return toCurrentTimeZone(date).format(this.dateformat)
    },
    getDateTime(date, timeformat = 'HH:mm:ss') {
      return toCurrentTimeZone(date).format(this.dateformat + ' ' + timeformat)
    },
    getDateTimeUTC(date) {
      return toCurrentTimeZone(date).utc().format(this.dateformat + ' ' + 'HH:mm:ss')
    },
    getDateCustom(date, custom) {
      return toCurrentTimeZone(date).format(custom.format)
    },
    getFriendlyTime(date) {
      return toCurrentTimeZone(date).startOf('minute').fromNow()
    },
    getDiffTime(timestamp, $t) {
      // Hours, minutes and seconds
      var time = moment().diff(timestamp, 'seconds', true)
      var hrs = ~~(time / 3600)
      var mins = ~~((time % 3600) / 60)
      var secs = time % 60

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = ''
      if (hrs > 0) {
        ret += '' + hrs + ' ' + $t.hours + ' '
      }
      if (mins > 0) {
        ret += '' + mins + ' ' + $t.minutes + ' '
      }
      ret += '' + secs.toFixed(0) + ' ' + $t.seconds
      return ret
    },
    getDurationFriendlyBySeconds(seconds, $t, show_seconds = true) {
      // Hours, minutes and seconds
      var time = seconds
      var hrs = ~~(time / 3600)
      var mins = ~~((time % 3600) / 60)
      var secs = time % 60

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = ''
      if (hrs > 0) {
        ret += '' + hrs + ' ' + $t('message.hours') + ' '
      }
      if (mins > 0) {
        ret += '' + mins + ' ' + $t('message.minutes') + ' '
      }
      if (show_seconds || seconds < 60) {
        ret += '' + secs.toFixed(0) + ' ' + $t('message.seconds')
      }
      return ret
    },

    getEngDate,

    getEngMonth,

    getThaiDate,

    getThaiMonth,

    getLocalDate(date, lang, { short = false }) {
      if (lang.toLowerCase() == 'en') {
        return getEngDate(date, this.dateformat, { short })
      } else if (lang.toLowerCase() == 'th') {
        return getThaiDate(date, this.dateformat, { short })
      }
    },

    getMyLocalDate(date, { short = false }) {
      if (this.getLang.toLowerCase() == 'en') {
        return getEngDate(date, this.dateformat, { short })
      } else if (this.getLang.toLowerCase() == 'th') {
        return getThaiDate(date, this.dateformat, { short })
      }
    },

    getMyLocalMonthYear(date, { short = false }) {
      const d = new Date(date)
      const month = (() => {
        if (this.getLang.toLowerCase() == 'en') {
          const months = short ? monthNamesEngSort : monthNamesEng
          return months[d.getMonth()]
        } else if (this.getLang.toLowerCase() == 'th') {
          const months = short ? monthNamesThaiSort : monthNamesThai
          return months[d.getMonth()]
        }
      })()
      const year = (() => {
        if (this.getLang.toLowerCase() == 'en') {
          return d.getFullYear()
        } else if (this.getLang.toLowerCase() == 'th') {
          return d.getFullYear() + 543
        }
      })()

      const formatArr = this.dateformat.split('/')
      return formatArr.reduce((acc, cur) => {
        if (cur === 'YYYY') {
          acc.push(year)
        } else if (cur === 'MM') {
          acc.push(month)
        }
        return acc
      }, []).join(' ')
    },

    getMyLocalYear(date, { short = false }) {
      const d = new Date(date)
      const year = (() => {
        if (this.getLang.toLowerCase() == 'en') {
          return d.getFullYear()
        } else if (this.getLang.toLowerCase() == 'th') {
          return d.getFullYear() + 543
        }
      })()
      return year
    },

    getLocalMonth,

    getDateMonthYear(date) {
      const d = moment(date)
      const m = getLocalMonth(d.format('M') - 1, this.getLang)
      const y = d.format('YYYY')
      return `${m} ${y}`
    },

    notify($vs, opts) {
      $vs.notify({
        title: opts.title || null,
        text: opts.text,
        color: opts.color,
        icon: opts.icon,
        time: opts.time || 1000 * 5,
        position: opts.position || 'top-right',
        click: opts.click ? opts.click : null,
      })
    },
    showLoading($progress, isLoading) {
      if (!loopLoading) {
        $progress.start()
        loopLoading = setInterval(() => {
          if ($progress.get() > 90) {
            $progress.pause()
          }
        }, 100)
      }
    },
    showFinish($progress) {
      $progress.finish()

      clearInterval(loopLoading)

      loopLoading = null

      store.dispatch('Loading', false)
    },
    showError($progress, $vs, msg, opts) {
      $progress.fail()

      $vs.notify({
        title: opts.title,
        text: msg || opts.text,
        color: 'warning',
        icon: 'warning',
        fixed: 'true',
        position: 'top-right',
      })

      clearInterval(loopLoading)

      loopLoading = null
    },
    leavePage($progress, clearStateArray, commonOptions) {
      // set progress to zero
      $progress.set(0)
      // clear state in array
      for (let i in clearStateArray) {
        store.dispatch(clearStateArray[i])
      }
      // remove modals
      removeModals()
      // remove tooltips
      removeTooltips()
      // trick window resize, if you use dataTable use must trick resize before destory to remove fixed header of table
      window.dispatchEvent(new Event('resize'))
    },
    checkAuth(opt) { // check install app and permissions
      // end this line
      if (!this.auth.shop_info || !this.auth.user_info) {
        return
      }

      let apps = this.auth.shop_info.install_apps
      let permissions = this.auth.user_info.permissions
      for (let i in apps) {
        let isInstall = apps[i].app_id == opt.app_id
        if (isInstall) {
          for (let j in permissions) {
            let isAllowPermission = apps[i].app_id == permissions[j].app_id
            if (isAllowPermission) {
              return true
            }
          }
        }
      }
      return false
    },
    isAllowPermission(opt) { // check only permissions
      let permissions = this.auth.user_info.permissions
      for (let i in permissions) {
        if (permissions[i].app_id == opt.app_id) {
          return true
        }
      }
      return false
    },
    // opt is object: {'app_id': 1}
    isInstallApp(opt) {
      let apps = this.auth.shop_info.install_apps
      for (let i in apps) {
        let isInstall = apps[i].app_id == opt.app_id
        if (isInstall) {
          return true
        }
      }
      return false
    },
    getColorFormStatus(status) {
      if (status == 'padding') {
        return 'warning'
      } else if (status == 'rejected') {
        return 'danger'
      } else if (status == 'uncompleted') {
        return 'info'
      } else if (status == 'completed') {
        return 'success'
      }
    },
    // this function support to po, so and in
    getTotal,
    // this function use to get taxes by orders
    getTaxesByOrders,
    // this function use to display taxes
    getFinalTaxes,
    // this function support to po, so, in and ex
    getPaidAmount(payments) {
      return getPaidTotal(payments)
    },
    // this function support to only po
    getDebtPurchaseAmount(purchase) {
      let grandTotal = getTotal(purchase.orders).grand
      let paidTotal = getPaidTotal(purchase.reference.payments)
      let result = grandTotal - paidTotal
      return result < 0 || purchase.status == 'rejected' || purchase.status == 'padding' ? 0 : result
    },
    // this function support to only ex
    getDebtExpenseAmount(expense) {
      let grandTotal = expense.payment.amount
      let paidTotal = getPaidTotal(expense.reference.payments)
      let result = grandTotal - paidTotal
      return result < 0 || expense.status == 'rejected' || expense.status == 'padding' ? 0 : result
    },
    // this function support to only so
    getDebtSaleAmount(sale) {
      let grandTotal = getTotal(sale.orders).grand
      let paidTotal = 0

      sale.reference.invoices.map(inv => {
        paidTotal += getPaidTotal(inv.reference.payments)
      })

      let result = grandTotal - paidTotal
      return result < 0 || sale.status == 'rejected' || sale.status == 'padding' || sale.reference.invoices.length == 0 ? 0 : result
    },
    // this function support to only in
    getDebtInvoiceAmount(invoice) {
      let grandTotal = getTotal(invoice.orders).grand
      let paidTotal = getPaidTotal(invoice.reference.payments)
      let result = grandTotal - paidTotal
      return result < 0 || invoice.status == 'rejected' || invoice.status == 'padding' ? 0 : result
    },
    // this function support to only rt
    getDebtReceiptAmount(receipt) {
      return 0
    },
    // this function support to only in
    getDebtPayslipAmount(item) {
      return item.process.debit
    },
    getS3Key(location) {
      let arr = location.split('amazonaws.com/')
      if (arr.length == 2) {
        return arr[1]
      }
      return null
    },
    getS3Bucket(location) {
      let a = location.split('.s3.')
      if (a.length == 2) {
        let b = a[0].split('://')
        var c = b[1]
        return c
      }
      return null
    },
    numberOnly(evt) {
      evt = (evt) || window.event
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45 && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    toLowerCase(evt) {
      evt = (evt) || window.event
      evt.target.value = evt.target.value.toLowerCase()
    },
    toEmailFormat(evt) {
      evt = (evt) || window.event

      var firstString = null

      if (evt.target.value.trim().length > 0) {
        firstString = evt.target.value[0]

        var reg = /^[a-zA-Z0-9]+$/
        var matches = firstString.match(reg)

        if (matches === null) {
          evt.target.value = evt.target.value.replace(new RegExp(firstString, 'g'), '')
        }
      }
    },
    setToValidNumber(number) {
      number = `${number}`
      if (number.toString().search('0') == 0 && number.toString().search('\\.') == -1) {
        number = parseFloat(number).toString()
      }
      if (!this.isANumber(number)) {
        number = '0'
      }
      return number
    },
    // use for input
    setToCustomDigitsNumber(number, opts) {
      const shop_info = this.auth.shop_info
      const settings = shop_info.settings
      const appearance = settings.general.appearance
      const format_number = appearance.format_number

      var place = format_number.decimal.place
      if (opts !== undefined) {
        if (opts.decimal >= 0) {
          place = opts.decimal
        }
      }

      return parseFloat(Math.round(number * 100) / 100).toFixed(place)
    },
    setToCustomDigitsNumberWithCheckEmpty(value, opts) {
      if (typeof value === 'string' && value.trim().length === 0) {
        return value
      } else if (value === null || value === undefined) {
        return value
      }
      return this.setToCustomDigitsNumber(value, opts)
    },
    getDefaultDataForOrderVue(orders) {
      var newOrders = []
      for (let i in orders) {
        let order = orders[i]

        var discount = {
          name: '',
          type: 'percentage',
          amount: '0.00',
        }

        var tax = {
          form_type: TAX_FORM_TYPE.TAX,
          name: '{vat}',
          type: '',
          amount: this.vat,
        }

        let discounts = []
        let taxes = []

        if (order.discounts.length > 0) {
          discount.name = order.discounts[0].name || ''
          discount.type = order.discounts[0].value_type
          discount.amount = this.setToCustomDigitsNumber(order.discounts[0].value_amount)
        }

        if (order.taxes.length > 0) {
          for (let j in order.taxes) {
            if (order.taxes[j].name == '{vat}') {
              tax.type = order.taxes[0].type
              tax.amount = order.taxes[0].amount
            }
          }
        }

        if (order.discounts.length) {
          discounts = order.discounts
        } else {
          discounts = [
            {
              value_type: 'percentage',
              value_amount: 0,
            },
          ]
        }

        if (order.taxes.length) {
          taxes = order.taxes
        }

        newOrders.push({
          sku_id: order.sku_id,
          item: order.item,
          description: order.description,
          quantity: this.setToCustomDigitsNumber(order.quantity),
          price: this.setToCustomDigitsNumber(order.price),
          cost: this.setToCustomDigitsNumber(order.cost),
          discounts: discounts,
          taxes: taxes,
          selectedTaxIds: taxes.map((tax) => tax.tax_id),
          selectize: {
            loading: false,
            updateOption: null,
            trickValidation: 0,
          },
          queryProductName: order.item,
          image: '',
          is_saving_product: false,
        })
      }
      return newOrders
    },
    updateDropdownPosition() {
      this.$nextTick(function () {
        let dropdown = $('.dropdown')
        let menu = $('.dropdown .dropdown-menu')
        let left = Math.round(dropdown.width() - menu.width() + 8)
        $('.dropdown .dropdown-menu').css({
          'transform': 'translate3d(' + left + 'px, 21px, 0px)',
        })
      })
    },
    closeDropdown() {
      $('body').trigger('click')
    },
    getDiscountCondition(conditions, quantity) {
      let result = null
      for (const con of conditions) {
        if (con.condition === '>=') {
          if (quantity >= con.quantity) {
            result = con
          }
        }
        if (con.condition === '=') {
          if (quantity == con.quantity) {
            result = con
          }
        }
        if (con.condition === '<=') {
          if (quantity <= con.quantity) {
            result = con
          }
        }
      }
      return result
    },
    loginLine(callback_options, callback) {
      window.handleResponse = function (err, res) {
        callback(err, res)
      }

      var width = 600
      var height = 600

      let getPosition = getCenterPosition(width, height, window)

      var app_uri = project.config.web.app
      var params = 'callback/login-with-line?app_id=' + callback_options.app_id + '&channel=line'
      var callback_uri = encodeURIComponent(app_uri + params)

      var params = '?goto=' + callback_uri
      var auth_line_uri = project.config.web.login_with_line + params

      let newtab = window.open(auth_line_uri, 'newtab', 'width=' + width + ', height=' + height + ', 0, status=0, top=' + (getPosition.top) + ', left=' + getPosition.left)

      // newtab.onload = function () {}
    },

    // clear tooltops html
    removeTooltips,

    cleanObject(query = {}) {
      return Object.keys(query).reduce((acc, cur) => {
        const key = cur
        const value = query[cur]

        if (value !== undefined && value !== null) {
          acc[key] = value
        }

        return acc
      }, {})
    },

    isFoundAnyStock(posProducts) {
      for (const tab of posProducts) {
        for (const product of tab.products) {
          for (const price of product.prices) {
            if (price.stocks.length) {
              return true
            }
          }
        }
      }
      return false
    },

    datePeriod(dateStart, dateEnd) {
      const lang = this.getLang
      const dateFormat = this.dateformat
      const start = moment(dateStart)
      const end = moment(dateEnd)

      var str = ''

      if (start.format(dateFormat) == end.format(dateFormat)) {
        str += this.getLocalDate(start, lang, { short: false })
      } else {
        if (start.format('M') == end.format('M') && start.format('YYYY') == end.format('YYYY')) {
          str += start.format('D')
          str += ' ' + this.$t('message.to').toLowerCase() + ' '
          str += this.getLocalDate(end, lang, { short: false })
        } else {
          if (start.format('YYYY') == end.format('YYYY')) {
            if (lang == 'en') {
              str += this.getLocalMonth(start.format('MM') - 1, lang)
              str += ' '
              str += start.format('D')
              str += ' - '
              str += this.getLocalDate(end, lang, { short: false })
            } else if (lang == 'th') {
              str += start.format('D')
              str += ' '
              str += this.getLocalMonth(start.format('MM') - 1, lang)
              str += ' - '
              str += this.getLocalDate(end, lang, { short: false })
            }
          } else {
            str += this.getLocalDate(start, lang, { short: false })
            str += ' - '
            str += this.getLocalDate(end, lang, { short: false })
          }
        }
      }

      return str
    },

    scrollToTop(duration) {
      // cancel if already on top
      if (document.scrollingElement.scrollTop === 0) return

      const cosParameter = document.scrollingElement.scrollTop / 2
      let scrollCount = 0, oldTimestamp = null

      const step = (newTimestamp) => {
        if (oldTimestamp !== null) {
          // if duration is 0 scrollCount will be Infinity
          scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration
          if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = 0
          document.scrollingElement.scrollTop = cosParameter + cosParameter * Math.cos(scrollCount)
        }
        oldTimestamp = newTimestamp
        window.requestAnimationFrame(step)
      }
      window.requestAnimationFrame(step)
    },

    getCurrencyWithNumber(value) {
      const currency = 'thb'
      if (currency === 'thb') {
        return `THB ${value}`
      } else if (currency === 'usd') {
        return `$${value}`
      }
      return value
    },

    currencyFormatter,

    showLegacyWht() {
      const hideInDays = 15
      const startDate = moment([2024, 6, 29])
      const effectDate = moment(startDate).add(hideInDays, 'days')
      const diffDays = moment(effectDate).diff(moment(), 'days')
      return diffDays > 0
    },

    sum(arr) {
      return arr.reduce((acc, cur) => acc + cur, 0)
    },

    blurInputAll() {
      const inputs = document.querySelectorAll('input')
      inputs.forEach(input => input.blur())
    },

    getModifierHelperText($t, modifier) {
      const messages = []
      if (modifier.is_required) {
        messages.push($t('message.requiredselect'))
      }
      if (modifier.min_required_count == modifier.max_required_count && modifier.max_required_count != 0) {
        messages.push($t('message.modifiertextcondition1', { number: modifier.min_required_count }))
      } else if (modifier.min_required_count != 0 && modifier.max_required_count == 0) {
        messages.push($t('message.modifiertextcondition2', { number: modifier.min_required_count }))
      } else if (modifier.min_required_count == 0 && modifier.max_required_count != 0) {
        messages.push($t('message.modifiertextcondition3', { number: modifier.max_required_count }))
      } else if (modifier.min_required_count != 0 && modifier.max_required_count != 0) {
        messages.push($t('message.modifiertextcondition4', { number1: modifier.min_required_count, number2: modifier.max_required_count }))
      }
      return messages.join(', ')
    },

    getModifierMaxSelected(modifier) {
      if (modifier.min_required_count == modifier.max_required_count && modifier.max_required_count != 0) {
        return modifier.max_required_count
      } else if (modifier.min_required_count != 0 && modifier.max_required_count == 0) {
        return 0
      } else if (modifier.min_required_count == 0 && modifier.max_required_count != 0) {
        return modifier.max_required_count
      } else if (modifier.min_required_count != 0 && modifier.max_required_count != 0) {
        return modifier.max_required_count
      }
    },

    replaceCodeToText(value, $t) {
      const valueString = `${value}`
      return splitBracedString(valueString).map((v) => getMasterDataText(v, $t)).join('')
    },

  },
}



// WEBPACK FOOTER //
// ./src/mixin.js